import React from 'react';

interface SpinnerProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'inline' | 'full-page';
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  text,
  size = 'md',
  variant = 'inline',
  className = '',
}) => {
  const sizeMap = { sm: 1, md: 2, lg: 3 };
  const iconSize = sizeMap[size];

  if (variant === 'full-page') {
    return (
      <div className={`text-center py-5 ${className}`}>
        <i className="fa fa-spinner fa-spin text-primary" style={{ fontSize: iconSize * 16 }}></i>
        {text && <p className="mt-3 text-muted">{text}</p>}
      </div>
    );
  }

  return (
    <span className={`text-muted ${className}`}>
      <i className="fa fa-spinner fa-spin me-1" style={{ fontSize: iconSize * 14 }}></i>
      {text}
    </span>
  );
};

export default Spinner;
